// extracted by mini-css-extract-plugin
module.exports = {"loadingButton":"LoadingButton_loadingButton__3AYVv","indicator":"LoadingButton_indicator__3_IsC"};